<ng-container *ngIf="isFormLoading; else formOrError">
  <div class="medical-inquiry-new-loading">
    <ion-spinner></ion-spinner>
    <p>{{ 'LOADING' | translate }}</p>
  </div>
</ng-container>
<ng-template #formOrError>
  <ng-container *ngIf="formDetail; else formNotConfigured">
    <ind-dynamic-form
      [MODE]="'CREATE_MODE'"
      [FORM_DETAIL]="formDetail"
      [LINKED_ENTITY_DB_PREFIX]="medicalInquiryLinkedEntityPrefix"
      [REF_ENTITY_NAME]="'indskr_medicalinquiryid'">
    </ind-dynamic-form>
  </ng-container>
  <ng-template #formNotConfigured>
    <div class="medical-inquiry-new-placeholder">
      <p>{{ 'DONT_HAVE_FORM_CONFIGURED_ERR' | translate }}</p>
      <ion-button fill="outline" (click)="medicalInquiryService.setShowNew(false)">
        {{ 'CANCEL' | translate }}
      </ion-button>
    </div>
  </ng-template>
</ng-template>
